//  "start": "set NODE_ENV=production && set HTTPS=true && react-scripts --max_old_space_size=8192 --openssl-legacy-provider start",
 // "start": "set NODE_ENV=development && react-scripts --max_old_space_size=8192 --openssl-legacy-provider start",
 
import React from 'react';
import api from './api';
import './Doctors.css';
import { QRCodeCanvas } from 'qrcode.react';  // Correct way for v4.x.x

import useAuth from "../hooks/useAuth";
import { useState, useEffect} from 'react';

const UpiPaymentQR = ({upid, amt}) => {
  const [upiId] = useState(upid);
  const [amount, setAmount] = useState(amt);

  // Keep amount in sync when parent passes a new amt
  useEffect(() => { setAmount(amt); }, [amt]);

  const upiUrl = `upi://pay?pa=${upiId}&pn=MedicalYogaTherapy&am=${amount}&tn=Payment for services&cu=INR`;

  return (
    <div style={{ textAlign: 'center', padding: '8px 0' }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#333', marginBottom: 8 }}>
        Scan to Pay · ₹{amount}
      </div>

      <QRCodeCanvas value={upiUrl} size={200} level="H" includeMargin={true} />

      <div style={{ marginTop: 8, fontSize: 12, color: '#555' }}>
        UPI ID: {upiId}
      </div>

      {/* Amount override */}
      <div style={{ marginTop: 10 }}>
        <input
          type="number"
          placeholder="Override amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          min="1"
          style={{ width: 120, padding: '4px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 6, textAlign: 'center' }}
        />
      </div>
    </div>
  );
};

export default UpiPaymentQR;
